import { render, staticRenderFns } from "./orderDetailTwo.vue?vue&type=template&id=1f13d73b&scoped=true&"
import script from "./orderDetailTwo.vue?vue&type=script&lang=js&"
export * from "./orderDetailTwo.vue?vue&type=script&lang=js&"
import style0 from "./orderDetailTwo.vue?vue&type=style&index=0&id=1f13d73b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f13d73b",
  null
  
)

export default component.exports